import { DynamicInput, FormField } from '@domain-group/suit-theme'

import usePublicationOptionValues from '@hooks/usePublicationOptionValues'

import type { PublicationOptionModel } from '@models/types'

interface PublicationOptionProps {
  callbacks: {
    updatePublicationBookingPageOption: (value?: string) => void,
  },
  currentValue: string,
  publicationOption: PublicationOptionModel,
}

const PublicationOption = (props: PublicationOptionProps) => {
  const {
    callbacks: {
      updatePublicationBookingPageOption,
    },
    currentValue,
    publicationOption: {
      id,
      input_type,
      placeholder_text,
      title,
    },
  } = props

  const publicationOptionValuesPayload = usePublicationOptionValues({
    filters: {
      publication_option_id: id,
    },
  })

  const {
    filteredPublicationOptionValues,
  } = publicationOptionValuesPayload

  return (
    <FormField
      label={title}
      marginTop="large"
    >
      <DynamicInput
        currentValue={currentValue}
        // @ts-expect-error TS2322
        inputComponent={input_type || 'input'}
        placeholder={placeholder_text}
        // @ts-expect-error TS18046
        values={filteredPublicationOptionValues.map(item => ({
          key: item.value,
          label: item.title,
        }))}
        onChange={e => updatePublicationBookingPageOption(e?.target?.value)}
      />
    </FormField>
  )
}

export default PublicationOption
